import { SingularStationArea } from '@thive/fddm-types';
import { Vector3 } from 'three';

import { ICommand } from '@/modules/canvas/commands/ICommand';
import { HistoryServiceFactory } from '@/modules/canvas/services/history/HistoryServiceFactory';
import { IHistoryService } from '@/modules/canvas/services/history/IHistoryService';

import { IFlowService } from './IFlowService';
import { FlowStopType } from '../store/useActiveFlowStore';

export class FlowServiceHistoryDecorator implements IFlowService {
  private decoree: IFlowService;
  private historySvc: IHistoryService;

  constructor(decoree: IFlowService) {
    this.decoree = decoree;
    this.historySvc = HistoryServiceFactory.getInstance().createHistoryService();
  }

  startFlow(
    pointA: Vector3,
    id: string,
    flowStopType: FlowStopType,
    loadHandlingType: SingularStationArea['loadHandlingType'],
    toolState: 'transport_flow' | 'consolidation_flow' | 'external_flow',
  ): void {
    this.decoree.startFlow(pointA, id, flowStopType, loadHandlingType, toolState);
  }

  endFlow(sourceId: string, destinationId: string): void {
    this.decoree.endFlow(sourceId, destinationId);
  }

  activateTool(type: 'transport_flow' | 'consolidation_flow' | 'external_flow'): void {
    this.decoree.activateTool(type);
  }

  cancelTool(): void {
    this.decoree.cancelTool();
  }

  //
  // Utility methods
  //

  private excuteAndTrack(command: ICommand) {
    command.execute();
    this.historySvc.track(command);
  }
}
